import { LogErrors } from './../../LogErrors'

import { DoubleAttempt } from './../Helpers/DoubleAttempt'


const GetAgendas = async (idCenter, token) => {
    try {
        const dataToSend = {
            idCenter: idCenter
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/GetScheduledEvaluationsForInstructor"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/GetScheduledEvaluationsForInstructor", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // const data = await response.json()
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetAgendas - DL Agendas', error)
        return { success: false, message: 'No ha sido posible obtener las evaluaciones agendadas. Intenta actualizar la página o intenta actualizarla más tarde.' }
    }
}

const GetCourses = async (idCenter, token) => { //idGroup
    try {
        const dataToSend = {
            idCenter: idCenter
            //idGroup: idGroup
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/GetCoursesByCenter"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // //const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/GetCoursesByGroupForAgenda", {
        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/GetCoursesByCenter", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // const data = await response.json()
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetCourses - DL Agendas', error)
        return { success: false, message: `No ha sido posible obtener los cursos disponibles del grupo. Inténtalo nuevamente o inténtalo más tarde.` }
    }
}

const GetEvaluations = async (idCenter, idCourse, token) => {
    try {
        const dataToSend = {
            idCenter: idCenter,
            idCourse: idCourse
        }

        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }
        
        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/GetEvaluationsByCourseForAgenda"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/GetEvaluationsByCourseForAgenda", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // const data = await response.json()
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetEvaluations - DL Agendas', error)
        return { success: false, message: `No ha sido posible obtener las evaluaciones. Inténtalo nuevamente o inténtalo más tarde.` }
    }
}

const CreateAgenda = async (agenda, token) => {
    try {
        let dataToSend

        if (agenda.isExist) {
            dataToSend = {
                Name: agenda.name,
                StartDate: agenda.startDate,
                FinishDate: agenda.finishDate,
                StartHour: agenda.startHour,
                FinishHour: agenda.finishHour,
                Oportunities: agenda.oportunities,
                IdItem: agenda.idItem,
                IdEvaluationType: agenda.type,
                IdGroup: agenda.idGroup,
                IdCourse: agenda.idCourse,
                isExist: true,
                idGroupCourse: agenda.idGroupCourse,
                IdAgenda: agenda.IdAgenda
            }
        } else {
            dataToSend = {
                Name: agenda.name,
                StartDate: agenda.startDate,
                FinishDate: agenda.finishDate,
                StartHour: agenda.startHour,
                FinishHour: agenda.finishHour,
                Oportunities: agenda.oportunities,
                IdItem: agenda.idItem,
                IdEvaluationType: agenda.type,
                IdGroup: agenda.idGroup,
                IdCourse: agenda.idCourse,
                isExist: false
            }
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/CreateOrUpdate"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/CreateOrUpdate", { // CreateAgenda
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // const data = await response.json()
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetEvaluations - DL Agendas', error)
        return { success: false, message: `No ha sido posible agendar la(s) evaluación(es) deseada(s). Inténtalo nuevamente o inténtalo más tarde.` }
    }
}

const RescheduleAgenda = async (agenda, token) => {
    try {
        const dataToSend = {
            idAgenda: agenda.idAgenda,
            startDate: agenda.startDate,
            finishDate: agenda.finishDate,
            startHour: agenda.startHour,
            finishHour: agenda.finishHour,
            currentOpportunities: agenda.currentOpportunities
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/RescheduleAgenda"

        const response = await DoubleAttempt(url, parameters, false)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/RescheduleAgenda", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: null }
    } catch (error) {
        await LogErrors('RescheduleAgenda - DL Agendas', error)
        return { success: false, message: `No ha sido posible reagendar la(s) evaluación(es) deseada(s). Inténtalo nuevamente o inténtalo más tarde.` }
    }
}

const DeleteAgenda = async (idAgenda, idCenter, idGroup, idCourse, idItem, token) => {
    try {
        const dataToSend = {
            idAgenda: idAgenda,
            idCenter: idCenter,
            idGroup: idGroup,
            idCourse: idCourse,
            idItem: idItem
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/DeleteAgenda"

        const response = await DoubleAttempt(url, parameters, false)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/DeleteAgenda", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: null }
    } catch (error) {
        await LogErrors('DeleteAgenda - DL Agendas', error)
        return { success: false, message: `No ha sido posible eliminar la(s) agenda(s) deseada(s). Inténtalo nuevamente o inténtalo más tarde.` }
    }
}

const GetExistingAgenda = async (group, course, item, token) => {
  try {
    // const dataToSend = {
    //     IdGroup: group,
    //     IdCourse: course,
    //     IdItem: item
    // }

    const dataToSend = {
        IdGroup: course,
        IdCourse: group,
        IdItem: item
    }
    
    const parameters = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
        body: JSON.stringify(dataToSend)
    }

    const url = process.env.REACT_APP_API_URL + "/api/V2/Api/GetExistingAgenda"

    const response = await DoubleAttempt(url, parameters)

    if (response.success) {
        return { success: true, data: response.data }
    } else {
        return { success: false, message: response.message }
    }

    // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/GetExistingAgenda", {
    //     method: 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': token
    //     },
    //     body: JSON.stringify(dataToSend)
    // })
    
    // if (!response.ok) {
    //     // Manejar errores HTTP
    //     const errorData = await response.json()
    //     //return { success: false, message: errorData.message || 'Error de autenticación' }
    //     return { success: false, message: errorData.message } //errorCode
    // }
    
    // const data = await response.json()
    
    // //Retornar la respuesta exitosa
    // return { success: true, data: data }
  } catch (error) {
    console.error('Error en GetExistingAgenda:', error)
    return { success: false, message: 'No ha sido posible obtener la información de la agenda deseada. Inténtalo nuevamente o inténtalo más tarde.' }
  }
}

const GetCourseProgressSummary = async (center, course, group, role, userIds, token) => {
  try {
    const dataToSend = {
        idCenter: center,
        idCourse: course,
        idGroup: group,
        idUserRol: role,
        userIds: userIds
    }
    
    const parameters = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
        body: JSON.stringify(dataToSend)
    }

    const url = process.env.REACT_APP_API_URL + "/api/V2/Api/GetCourseProgressSummary"

    const response = await DoubleAttempt(url, parameters)

    if (response.success) {
        return { success: true, data: response.data }
    } else {
        return { success: false, message: response.message }
    }

    // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/GetCourseProgressSummary", {
    //     method: 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': token
    //     },
    //     body: JSON.stringify(dataToSend)
    // })
    
    // if (!response.ok) {
    //     // Manejar errores HTTP
    //     const errorData = await response.json()
    //     //return { success: false, message: errorData.message || 'Error de autenticación' }
    //     return { success: false, message: errorData.message } //errorCode
    // }
    
    // const data = await response.json()
    
    // //Retornar la respuesta exitosa
    // return { success: true, data: data }
  } catch (error) {
    console.error('Error en GetCourseProgressSummary:', error)
    return { success: false, message: 'No ha sido posible obtener la información deseada. Inténtalo nuevamente o inténtalo más tarde.' }
  }
}

export { GetAgendas, GetCourses, GetEvaluations, CreateAgenda, RescheduleAgenda, DeleteAgenda, GetExistingAgenda, GetCourseProgressSummary };